import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { PAGES } from '../../../../router/routes'
import notaFiscalManager from '../../../../services/api/notaFiscal/notaFiscalManager'
import { RegraNotaFiscal } from '../../../../types/notaFiscalApiTypes'
import { tabNotaFiscalStyles } from './TabNotaFiscal.styles'

export function tabNotaFiscalIO() {
  const dispatch = useDispatch()
  const router = useHistory()
  const { parceiroId } = useParams<{ parceiroId: string }>()
  const [regrasList, setRegrasList] = useState<RegraNotaFiscal[]>([])
  const [modalAberto, setModalAberto] = useState(false)

  const buscarRegrasNotaFiscal = React.useCallback(async () => {
    dispatch(loadingUpdate(true))
    const response: RegraNotaFiscal[] = await notaFiscalManager.buscarRegras(parceiroId)
    setRegrasList(response)
    dispatch(loadingReset())
  }, [dispatch, parceiroId])

  const handleAdicionar = () => {
    router.push(PAGES.transformacaoNotaFiscalCadastro(parceiroId))
  }

  function fecharModal() {
    setModalAberto(false)
  }

  const handlePriorizar = () => {
    setModalAberto(true)
  }

  const getCampos = () => {
    return regrasList.map((item) => item.campo).filter((value, index, self) => self.indexOf(value) === index)
  }

  React.useEffect(() => {
    buscarRegrasNotaFiscal()
  }, [buscarRegrasNotaFiscal, dispatch, parceiroId])

  return {
    styles: tabNotaFiscalStyles,
    handleAdicionar,
    regrasList,
    buscarRegrasNotaFiscal,
    modalAberto,
    fecharModal,
    handlePriorizar,
    getCampos,
    parceiroId
  }
}

export type TabNotaFiscalIO = ReturnType<typeof tabNotaFiscalIO>
